import styled from 'styled-components';
import { BP_MOBILE_MAX } from '../../../assets/styles/breakpoints';

export default styled.div`
  .bottom-wrap {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    span {
      padding-bottom: 16px;
    }
    small {
      padding: 16px 0 0 0;
      margin: 0 auto;
    }
    .half-wrap {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      button {
        width: calc(50% - 10px);
      }
    }
  }

  @media (max-width: ${BP_MOBILE_MAX}px) {
    .bottom-wrap {
      .half-wrap {
        flex-direction: column;
        button {
          width: 100%;
          &:last-child {
            margin-top: 10px;
          }
        }
      }
    }
  }
`;
